/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPatientDataSharingDto
 */
export interface RequestPatientDataSharingDto {
    /**
     * Patient email address
     * @type {string}
     * @memberof RequestPatientDataSharingDto
     */
    email: string;
}

/**
 * Check if a given object implements the RequestPatientDataSharingDto interface.
 */
export function instanceOfRequestPatientDataSharingDto(value: object): value is RequestPatientDataSharingDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RequestPatientDataSharingDtoFromJSON(json: any): RequestPatientDataSharingDto {
    return RequestPatientDataSharingDtoFromJSONTyped(json, false);
}

export function RequestPatientDataSharingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPatientDataSharingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function RequestPatientDataSharingDtoToJSON(json: any): RequestPatientDataSharingDto {
    return RequestPatientDataSharingDtoToJSONTyped(json, false);
}

export function RequestPatientDataSharingDtoToJSONTyped(value?: RequestPatientDataSharingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

